"use client";

import { useTranslations } from "next-intl";
import { FaqHubView } from "@/components/faq/FaqHubView";
import { parseFaqCategories } from "@/components/faq/parseFaqContent";

/**
 * FAQ hub that reads category copy from the active client locale.
 */
export function FaqPageClient() {
  const t = useTranslations("faq");
  const categories = parseFaqCategories(t.raw("categories"));

  return (
    <FaqHubView
      title={t("title")}
      subtitle={t("subtitle")}
      hubIntro={t("hubIntro")}
      backLabel={t("backToEvents")}
      categories={categories}
    />
  );
}
